// Custom lazy load
function setfilter() {

    // Artist Single
    const setsocials = $('#asocial');

    if (setsocials.length) {

        setsocials.fadeTo(1, .01);

        const artistSlug = setsocials.data('artist');
        const artistURL = `https://artists.ultramusicfestival.com/artist/${artistSlug}/`;

        $.get(artistURL).done(artist => {

            const socialMappings = {
                'website': { icon: 'fas fa-globe', prefix: '', name: 'Website' },
                'facebook': { icon: 'fab fa-facebook', prefix: 'https://www.facebook.com/', name: 'Facebook' },
                'twitter': { icon: 'fab fa-x-twitter', prefix: 'https://www.twitter.com/', name: 'Twitter' },
                'instagram': { icon: 'fab fa-instagram', prefix: 'https://instagram.com/', name: 'Instagram' },
                'youtube': { icon: 'fab fa-youtube', prefix: 'https://www.youtube.com/', name: 'YouTube' },
                'soundcloud': { icon: 'fab fa-soundcloud', prefix: 'https://soundcloud.com/', name: 'Soundcloud' },
                'apple_music': { icon: 'fab fa-apple', prefix: '', name: 'Apple Music' },
                'spotify': { icon: 'fab fa-spotify', prefix: '', name: 'Spotify' }
            };

            let output = '<ul class="social clearfix mb25">';

            for (const key in socialMappings) {
                if (socialMappings.hasOwnProperty(key) && artist[key]) {
                    const { icon, prefix, name } = socialMappings[key];
                    output += `<li><a href="${prefix}${artist[key]}" title="${artist.title} ${name}" target="_blank"><span class="${icon}"></span></a></li>`;
                }
            }

            output += '</ul>';

            setsocials.html(output);
            setTimeout(() => { setsocials.fadeTo(400, 1); }, 500);
        });
    }

    if ($('.filternav').length) {
        $('.filternav').on({
            mouseenter: function() {
                $(this).find('li.selected').addClass('hover');
            },
            mouseleave: function() {
                $(this).find('li.selected').removeClass('hover');
            }
        });

        $('.filternav a.dd').on('click', function() {
            $('li.selected.hover').removeClass('hover');
            $(this).parent().addClass('hover');
        });
    }



    if( ! $('ul.filters a').length ) {
        return;
    }

    $('ul.filters a').on('click', function() {
        var el = $(this);

        $('.notfound').hide();
        el.parent().parent().find('li>a.active').removeClass('active');
        el.addClass('active');


        $('li.selected.hover').removeClass('hover');

        var day = $('#dayfilter .filters a.active');
        var stage = $('#stagefilter .filters a.active');

        // Update Filter Text
        $('.notfound').find('.day').text(day.text());
        $('.notfound').find('.stage').text(stage.text());
        el.parents('li.selected').removeClass('hover').find('a.dd strong').text(el.text());

        // Update Filter Selector
        day = day.data('day');
        stage = stage.data('stage');

        log(day);

        if(day == 'all') {
            day = '';
        } else {
            day = '.'+day;
        }
        if(stage == 'all') {
            stage = '';
        } else {
            stage = '.'+stage;
        }


        if(day != 'all') {
            $('#stagefilter ul.filters>li>a:not(.all)').parent().hide();
            $('#stagefilter ul.filters>li a'+day).parent().show();
        }

        // If Nothing Found
        if($('.setslist, .anav').find(`li${stage}${day}`).length == 0) {
            $('.notfound').fadeIn(300);
        }

        $('.setslist, .anav').find('li').stop(true,false).hide();
        $('.setslist').find('li'+day+stage).addClass('filtered').stop(true,false).fadeIn(250);
        $('.anav').find('li'+day+stage).addClass('filtered').stop(true,false).fadeIn(250);

    });




}
